import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
const MIXPANEL_PROXY_HOST = `${(process.env.REACT_APP_API_ENDPOINT || '').replace(/\/$/, '')}/mp`;

if (MIXPANEL_TOKEN && process.env.NODE_ENV === "production") {
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    api_host: `${MIXPANEL_PROXY_HOST}/api`,
    lib_base_path: `${MIXPANEL_PROXY_HOST}/libs/`,
  } as any);  
} else {
  console.warn("Mixpanel token bulunamadı");
}

const isEnabled = !!MIXPANEL_TOKEN && process.env.NODE_ENV === "production";

export const mp = {
  track: (event: string, props?: Record<string, any>) => {
    if (!isEnabled) return;
    try {
      mixpanel.track(event, props);
    } catch (error) {
      console.error("Mixpanel track failed", event, error);
    }
  },
  identify: (userId: string) => {
    if (!isEnabled) return;
    try {
      mixpanel.identify(userId);
    } catch (error) {
      console.error("Mixpanel identify failed", error);
    }
  },
  alias: (userId: string) => {
    if (!isEnabled) return;
    try {
      mixpanel.alias(userId);
    } catch (error) {
      console.error("Mixpanel alias failed", error);
    }
  },
  peopleSet: (props: Record<string, any>) => {
    if (!isEnabled) return;
    try {
      mixpanel.people.set(props);
    } catch (error) {
      console.error("Mixpanel peopleSet failed", error);
    }
  },
};
